import React from 'react';
import { Star } from 'lucide-react';
interface MiniProps {
  initials: string;
  name: string;
  role: string;
  country: string;
  text: string;
}
const Mini = ({
  initials,
  name,
  role,
  country,
  text
}: MiniProps) => <div className="bg-white border-2 border-brand-navy rounded-lg p-3 brunson-shadow" data-id="element-202">
    <div className="flex items-center gap-2 mb-2" data-id="element-203">
      <div className="w-8 h-8 rounded-full bg-brand-navy text-white font-display font-bold text-xs flex items-center justify-center shrink-0" data-id="element-204">
        {initials}
      </div>
      <div className="flex-1 min-w-0" data-id="element-205">
        <div className="flex text-brand-orange" data-id="element-206">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-207" />)}
        </div>
        <p className="text-[11px] font-bold text-brand-navy truncate" data-id="element-208">{name}</p>
        <p className="text-[9px] text-brand-mute font-medium" data-id="element-209">
          {role} · {country}
        </p>
      </div>
    </div>
    <p className="text-xs text-brand-ink italic leading-snug font-medium" data-id="element-210">
      "{text}"
    </p>
  </div>;
export function SocialProofBar() {
  const items = [{
    initials: 'CM',
    name: 'Ing. Carlos Mejía',
    role: 'Docente de Producción Acuícola',
    country: 'Colombia',
    text: 'El lunes tenía que explicar el ciclo del nitrógeno y el biofloc. El viernes anterior descubrí Acuicultura Pro. El lunes lo dicté con tablas listas, actividades prácticas y los alumnos lo entendieron al primer intento.'
  }, {
    initials: 'AT',
    name: 'Prof. Ana Lucía Torres',
    role: 'Capacitadora técnica',
    country: 'Ecuador',
    text: 'Mis estudiantes de camarón pasaron de no saber calcular el FCR a diseñar planes de alimentación completos. El sistema hace el 80% del trabajo del docente.'
  }, {
    initials: 'RS',
    name: 'Téc. Rodrigo Saavedra',
    role: 'Instructor técnico',
    country: 'Chile',
    text: 'Llevaba 3 años improvisando materiales de acuicultura de diferentes fuentes. Esto lo reemplaza todo. Y lo supera.'
  }];
  return <section className="bg-brand-creamAlt py-5 px-4 border-y-2 border-brand-line" data-id="element-211">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-212">
        {items.map((it, i) => <Mini key={i} {...it} data-id="element-213" />)}
      </div>
    </section>;
}